import {
  useAnalytics,
  LegacyAnalyticsEventData,
} from '@scentregroup/shared/analytics'
import {
  affiliations,
  events,
} from '@scentregroup/shared/helpers/analytics-utils/constants'
import makeUniqueProductId from '@scentregroup/shared/helpers/make-unique-product-id'
import useDeepCompareEffect from 'use-deep-compare-effect'
import {
  IMarketplaceProductVariant,
  MarketplaceProduct,
} from '../types/marketplace-product'

export const useTrackVariantSelectionAnalytics = (
  product: MarketplaceProduct,
  selectedVariant: IMarketplaceProductVariant
): void => {
  const analytics = useAnalytics()

  const data = makeAnalyticsEventData(product, selectedVariant)

  useDeepCompareEffect(() => {
    analytics.trackEvent({ type: 'legacy', data })
  }, [data])
}

function makeAnalyticsEventData(
  product: MarketplaceProduct,
  selectedVariant: IMarketplaceProductVariant
): LegacyAnalyticsEventData {
  const eligiblePromotion = selectedVariant.promotions?.[0]

  return {
    event: events.VIEW_ITEM,
    ecommerce: {
      currencyCode: 'AUD',
      affiliation: affiliations.WESTFIELD_DIRECT_AU,
      detail: {
        products: [
          {
            name: selectedVariant.title,
            id: selectedVariant.variantGroupCode ?? selectedVariant.sku,
            uniqueId: makeUniqueProductId(
              selectedVariant.id,
              product.shop.id,
              selectedVariant.sku
            ),
            price:
              selectedVariant.discountPrice || selectedVariant.originalPrice,
            brand: product.brand,
            category: product.category?.path
              .map(pathSegment => pathSegment.title)
              .join(' / '),
            variant: selectedVariant.optionValues.map(o => o.value).join('|'),
            dimension127: product.shop.name,
            dimension128: product.shop.retailerId,
            dimension129: 'AUD',
            ...(eligiblePromotion && {
              dimension131: eligiblePromotion.campaignId,
              dimension132: eligiblePromotion.title,
            }),
            dimension136: selectedVariant.variantGroupCode,
            dimension137: selectedVariant.sku,
            dimension138: product.shop.id,
          },
        ],
      },
    },
  }
}
